/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddFeedbackRequestModel,
  IAddFeedbackRequestRequest,
  IMappers,
  IAddFeedbackRequestResponse,
  IAddFeedbackRequestResponseError,
  TAddFeedbackRequestResponse,
} from './types';

const defaultConfig: TAddFeedbackRequestModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'moderation-complaints',
  pathApi: '/v1/add-feedback-request/',
  hostType: 'ud-api',
} as TAddFeedbackRequestModel;

function createAddFeedbackRequestModel(parameters: IAddFeedbackRequestRequest): TAddFeedbackRequestModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFeedbackRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddFeedbackRequestRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddFeedbackRequest<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddFeedbackRequestOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TAddFeedbackRequestResponse
> {
  const { response, statusCode } = await httpApi.fetch(createAddFeedbackRequestModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFeedbackRequestResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddFeedbackRequestResponseError);
    }
  }

  return { response, statusCode } as TAddFeedbackRequestResponse;
}

export { defaultConfig, createAddFeedbackRequestModel, fetchAddFeedbackRequest };
